export const GET_EXERCISE_REQUEST = 'ExercisePage/GET_EXERCISE_REQUEST';
export const GET_EXERCISE_SUCCESS = 'ExercisePage/GET_EXERCISE_SUCCESS';
export const GET_EXERCISE_FAILURE = 'ExercisePage/GET_EXERCISE_FAILURE';
export const SET_EXERCISE_RATING_REQUEST = 'ExercisePage/SET_EXERCISE_RATING_REQUEST';
export const SET_EXERCISE_RATING_SUCCESS = 'ExercisePage/SET_EXERCISE_RATING_SUCCESS';
export const SET_EXERCISE_RATING_FAILURE = 'ExercisePage/SET_EXERCISE_RATING_FAILURE';
